export default __webpack_public_path__ + "media/products/paper-41689650.png";